<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb mt-4">
            <li class="breadcrumb-item"><a @click="$router.push('/')" href="#">Україна</a></li>
            <li v-for="(item, index) in path" :key="index" class="breadcrumb-item active" aria-current="page">
                {{ item }}
            </li>
        </ol>
    </nav>
</template>

<script>
export default {
    name: "Breadcrumbs",
    props: ["device", "nominative"],
    computed: {
        path() {
            return this.device?.group?.path || this.nominative?.display_name || null;
        },
    },
}
</script>

<style scoped>

</style>